import * as React from 'react';

export default class ErrorBoundary extends React.Component<{fallback, children}, { hasError: boolean }> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    componentDidCatch(error, info) {
        // logErrorToMyService(
        //     error,
        //     // Example "componentStack":
        //     //   in ComponentThatThrows (created by App)
        //     //   in ErrorBoundary (created by App)
        //     //   in div (created by App)
        //     //   in App
        //     info.componentStack,
        //     // Warning: `captureOwnerStack` is not available in production.
        //     // Removed invalid React.captureOwnerStack() call
        // );
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.fallback;
        }

        return this.props.children;
    }
}